import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import { IPaySlipLandingPage, IFetchDataPayload } from "@/selfdisclosure.interfaces";

import PaySlipQuery from "@/graphql/PaySlipLandingPage";

/**
 * @returns {IPaySlipLandingPage}
 * @description
 * State defaults
 */
function stateDefaults(): IPaySlipLandingPage {
    return {
        available: false,
        error: "",
        info: {
            gender: "",
            firstName: "",
            lastName: "",
            monthlyNetIncome1: 0,
            monthlyNetIncome2: 0,
            monthlyNetIncome3: 0,
            monthlyIncomeRenting: 0,
            monthlyIncomeOther: 0,
            type: ""
        }
    };
}

@Module({ namespaced: true, name: "PaySlipStore" })
export default class PaySlip extends VuexModule {
    data: IPaySlipLandingPage = stateDefaults();

    error = "";
    isLoading = false;

    get getInfo() {
        return this.data.info;
    }

    get getFullPaySlip() {
        return this.data;
    }

    @Mutation
    setFullPaySlip(payload: IPaySlipLandingPage) {
        this.data = { ...this.data, ...payload };
    }

    @Mutation
    setError(payload: string) {
        this.error = payload;
    }

    @Mutation
    setLoading(payload: boolean) {
        this.isLoading = payload;
    }

    @Mutation
    reset() {
        const defaultData = stateDefaults();
        this.data = { ...this.data, ...defaultData };
        this.error = "";
        this.isLoading = false;
    }

    @Action({ rawError: true })
    fetchData({ apollo, variables }: IFetchDataPayload) {
        this.context.commit("setLoading", true);

        return apollo.query({
            query: PaySlipQuery,
            variables
        }).then(({ data: { paySlipLandingPage } }: { data: { paySlipLandingPage: IPaySlipLandingPage } }) => {
            this.context.commit("setLoading", false);
            this.context.commit("setFullPaySlip", paySlipLandingPage);

            return paySlipLandingPage;
        }).catch((error: Error) => {
            this.context.commit("setLoading", false);
            this.context.commit("setError", error);
        });
    }
}
